import logo from "./logo.png";

export const LogoImage = logo;
